import { render, staticRenderFns } from "./PostFacebook.vue?vue&type=template&id=1ab6964a&"
import script from "./PostFacebook.vue?vue&type=script&lang=js&"
export * from "./PostFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports